import {
  EventRecurrence,
  ProposalRecurrenceInput,
  RecurrenceIntervalTypeEnum,
  RepeatingEventSaveOption,
} from "@clockwise/schema";
import { SelectableRecurrenceOption } from "../../../event-card/molecules/ECRecurrence";
import { isStandardRecurrence } from "../../../web-app-calendar/hooks/useEditExistingEvent.util";

export const shouldUpdateThisAndFutureEvents = (
  saveOption: RepeatingEventSaveOption,
  oldRecurrence: EventRecurrence | undefined,
  newRecurrence: string,
) => {
  //Alse return true if user is turning off recurrence
  if (newRecurrence === "None" && oldRecurrence?.intervalType !== RecurrenceIntervalTypeEnum.NONE) {
    return RepeatingEventSaveOption.ThisAndFutureInstances;
  }
  return saveOption;
};

export const getRecurrenceToSave = (
  recurrence: SelectableRecurrenceOption | string,
  originalRecurrence?: EventRecurrence,
): ProposalRecurrenceInput | null => {
  if (isStandardRecurrence(recurrence)) {
    switch (recurrence) {
      case "None":
        return {
          intervalType: RecurrenceIntervalTypeEnum.NONE,
          intervalCount: 0,
        };
      case "Weekdays":
        return {
          intervalType: RecurrenceIntervalTypeEnum.DAILY,
          intervalCount: 1,
        };
      case "Weekly":
        return {
          intervalType: RecurrenceIntervalTypeEnum.WEEKLY,
          intervalCount: 1,
        };
      case "Biweekly":
        return {
          intervalType: RecurrenceIntervalTypeEnum.WEEKLY,
          intervalCount: 2,
        };
      case "Monthly":
        return {
          intervalType: RecurrenceIntervalTypeEnum.MONTHLY,
          intervalCount: 1,
        };
      default:
        return null;
    }
  }
  if (originalRecurrence) {
    return {
      intervalType: originalRecurrence.intervalType,
      intervalCount: originalRecurrence.intervalCount,
    };
  }
  return null;
};
